import { render } from "./BotaoComponent.vue?vue&type=template&id=00294ce1&ts=true"
import script from "./BotaoComponent.vue?vue&type=script&lang=ts"
export * from "./BotaoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Botoes/BotaoComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00294ce1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00294ce1', __exports__)) {
    api.reload('00294ce1', __exports__)
  }
  
  module.hot.accept("./BotaoComponent.vue?vue&type=template&id=00294ce1&ts=true", () => {
    api.rerender('00294ce1', render)
  })

}


export default __exports__